export default __webpack_public_path__ + "static/media/authenteklogo.cc4da08e.png";